import React from 'react'
import { graphql, Link } from 'gatsby'

import PageHeader from '../components/PageHeader'
import Content from '../components/Content'
import Layout from '../components/Layout'
import PostSection from '../components/PostSection'
import { allFutureEvents } from '../templates/EventsIndex'

// Export Template for use in CMS preview
export const HomePageTemplate = ({
  title,
  subtitle,
  CTAButton,
  CTALink,
  CTAButton2,
  CTALink2,
  CTAButtonExternal,
  CTALinkExternal,
  featuredImage,
  body,
  events = []
}) => {
  let futureEvents = events && !!events.length ? allFutureEvents(events) : []
  return (
    <main className="Home">
      <PageHeader
        large
        title={title}
        subtitle={subtitle}
        CTAButton={CTAButton}
        CTALink={CTALink}
        CTAButton2={CTAButton2}
        CTALink2={CTALink2}
        CTAButtonExternal={CTAButtonExternal}
        CTALinkExternal={CTALinkExternal}
        backgroundImage={featuredImage}
      />

      {!!events.length && (
        <section className="section">
          <div className="container">
            <h2>Upcoming Events</h2>
            {!!futureEvents.length ? (
              <PostSection posts={futureEvents} />
            ) : (
              <p>
                Want to host a virtual Townhall at your school?{' '}
                <Link to="/contact/"> Send us a note</Link>
              </p>
            )}
          </div>
        </section>
      )}

      <section className="section">
        <div className="container">
          <Content source={body} />
        </div>
      </section>
    </main>
  )
}

// Export Default HomePage for front-end
const HomePage = ({ data: { page, events } }) => (
  <Layout meta={page.frontmatter.meta || false}>
    <HomePageTemplate
      {...page}
      {...page.frontmatter}
      body={page.html}
      events={events.edges.map(event => ({
        ...event.node,
        ...event.node.frontmatter,
        ...event.node.fields
      }))}
    />
  </Layout>
)

export default HomePage

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query HomePage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      ...Meta
      html
      frontmatter {
        title
        subtitle
        CTAButton
        CTALink
        CTAButton2
        CTALink2
        CTAButtonExternal
        CTALinkExternal
        featuredImage
      }
    }
    events: allMarkdownRemark(
      filter: { fields: { contentType: { eq: "events" } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            date
            featuredImage
          }
        }
      }
    }
  }
`
